import { render, staticRenderFns } from "./BrandCarouselPage.vue?vue&type=template&id=9c06c41e&"
import script from "./BrandCarouselPage.vue?vue&type=script&lang=js&"
export * from "./BrandCarouselPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports